import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthStore } from '@/features/auth-store.service';

import { SidebarComponent } from '@/layout/sidebar/sidebar.component';
import { TopbarComponent } from '@/layout/topbar/topbar.component';
import { ToastLayerComponent } from '@/layout/toast-layer/toast-layer.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, TopbarComponent, ToastLayerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.component.scss',
  templateUrl: './app.component.html',
})
export class AppComponent {
  private authStore = inject(AuthStore);
  protected isAuthenticated = this.authStore.isAuthenticated;
}
